module.exports = __webpack_public_path__ + "static/img/wuxian-4.9818cc48.png";